import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function MenuImagesSection( {ImageUrls,VideoUrls}) {
  // Data for your images, including navigation paths

  let imageItemUrls = ImageUrls
  let videoItemUrls = VideoUrls

  const imageData = [
    {
      src: imageItemUrls.image4.url, // Assuming this is the full image you uploaded
      alt: imageItemUrls.image4.altText,
      text: "OUR STUDIO",
      navPath: "/studio" // Example navigation path
    },
    {
      src: imageItemUrls.image5.url, // Assuming this is the full image you uploaded
      alt: imageItemUrls.image5.altText,
      text: "OUR AGENCY",
      navPath: "/agency"
    },
    {
      src: imageItemUrls.image6.url, // Assuming this is the full image you uploaded
      alt: imageItemUrls.image6.altText,
      text: "OUR GYM",
      navPath: "/gym"
    },
    {
      src: imageItemUrls.image7.url, // Assuming this is the full image you uploaded
      alt: imageItemUrls.image7.altText,
      text: "OUR CREATIVE SPACE",
      navPath: "/creative-space"
    }
  ];

  const containerRef = useRef(null);
  const imageCardRefs = useRef([]); // To hold refs for individual image cards

  useEffect(() => {
    const container = containerRef.current;
    const imageCards = imageCardRefs.current;

    // Staggered animation for individual image cards
    gsap.fromTo(imageCards,
      { opacity: 0, y: 50, scale: 0.9 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.15, // Delay between each card animation
        scrollTrigger: {
          trigger: container,
          start: 'top 80%', // Animation starts when the top of the container is 80% down from the viewport top
          toggleActions: 'play none none none', // Play once when entering, do nothing otherwise
        },
      }
    );

  }, []);

  return (
    <>
      <style jsx>{`
        .menu-section-container {
          display: flex;
          justify-content: center;
          align-items: center;
          // background-color: black; 
          background-color: #808080; 
          padding: 100px 20px 100px 20px; /* Add some padding around the section */
          gap: 20px; /* Space between image containers */
          flex-wrap: wrap; /* Allow items to wrap on smaller screens */
        }

        .image-card {
          position: relative;
          width: 280px; /* Fixed width for each image card */
          height: 350px; /* Fixed height for each image card */
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.3s ease-in-out; /* Smooth transition for hover effect */
          display: flex;
          flex-direction: column;
          justify-content: flex-end; /* Align content to the bottom */
          align-items: flex-start; /* Align content to the left */
          text-align: left; /* Align text to the left */
          border: 1px solid #333; /* Subtle border */
          text-decoration: none; /* Remove underline from the link */
        }

        .image-card:hover {
          transform: translateY(-5px); /* Slight lift on hover */
        }

        .image-card img {
          width: 100%;
          height: 100%;
          object-fit: obtain; /* Cover the container without distortion */
          filter: brightness(0.6); /* Dull on start */
          transition: filter 0.3s ease-in-out; /* Smooth transition for brightness */
          position: absolute;
          top: 0;
          left: 0;
        }

        .image-card:hover img {
          filter: brightness(1); /* Bright on hover */
        }

        .star-icon {
          position: absolute;
          top: 15px;
          right: 15px; /* Changed from left to right */
          color: white; /* Star color */
          font-size: 30px; /* Star size */
          z-index: 2; /* Ensure star is above image */
          pointer-events: none; /* Allows clicks to pass through */
        }

        .image-text {
          position: relative; /* Position relative to allow z-index */
          color: white;
          font-family: 'Impact', 'Arial Black', sans-serif;
          font-size: 1.3rem;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 20px; /* Space from the bottom of the card */
          margin-left: 20px; /* Add margin to the left for text */
          z-index: 1; /* Ensure text is above image */
          pointer-events: none; /* Allows clicks to pass through */
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .menu-section-container {
            flex-direction: column; /* Stack items vertically on mobile */
            padding: 50px 10px 50px 10px;
          }

          .image-text {
            font-size: 1rem; /* Adjust font size for mobile */
            margin-left: 15px; /* Adjust margin for mobile */
          }
        }
      `}</style>

      <div className="menu-section-container" ref={containerRef}>
        {imageData.map((item, index) => (
          <a href={item.navPath} key={index} className="image-card" ref={el => (imageCardRefs.current[index] = el)}>
            <img src={item.src} alt={item.alt} />
            <span className="star-icon">★</span> {/* Star icon */}
            <div className="image-text">{item.text}</div>
          </a>
        ))}
      </div>
    </>
  );
}

export default MenuImagesSection;